// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"45340d44","239":"126ecbf9","551":"534eda74","644":"df2b43c1","667":"1bee7fe1","683":"52325684","851":"2d147401"}[chunkId] + ".chunk.js";
};